import React from 'react'
import Component from 'ui/pages/med/SystemError'

const SystemError: React.FC = () => {
  return <Component />
}

export default SystemError
